import "./LanguageSwitcher.css";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

const LanguageSwitcher = () => {

  let lngs = [
    { class: "United Kingdom", id: "en", name: window.innerWidth < 1100 ? "English" : "EN" },
    { class: "Estonia", id: "est", name: window.innerWidth < 1100 ? "Estonian" : 'EST' },
    { class: "Bulgaria", id: "bg", name: window.innerWidth < 1100 ? "Bulgarian" : "BG" }
  ]

  const { i18n } = useTranslation();
  const switcherRef = useRef();
  const [activeFlag, setActiveFlag] = useState(lngs[2]);
  const [langMenuDisplay, setLangMenuDisplay] = useState('none');
  const [lngsDropdown, setLngsDropdown] = useState(() => {
    let spliced = [...lngs];
    spliced.pop();
    return spliced
  });

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClickOutside = (e) => {
    if (switcherRef.current && !switcherRef.current.contains(e.target)) {
      setLangMenuDisplay('none');
    }
  }

  const setDropdownLangs = (lngSelected) => {
    const index = lngs.findIndex(lng => lng.id === lngSelected.id);
    const newLngs = [...lngs];
    newLngs.splice(index, 1);
    setLngsDropdown(newLngs)
  }

  const selectLang = (lng) => {
    changeLanguage(lng.id)
    setActiveFlag(lng);
    setDropdownLangs(lng);
    setLangMenuDisplay('none');
  }

  const showLangDropdown = () => {
    if (langMenuDisplay === 'none') {
      setLangMenuDisplay('block');
    } else {
      setLangMenuDisplay('none');
    }
  }

  return (
    <div className="lang_switcher">
      <div className="lang_button_wrapper" onClick={showLangDropdown}>
        <button className="lang_btn" >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 22" fill="none">
          <path d="M1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 1.04932C12 1.04932 15 4.99994 15 10.9999C15 16.9999 12 20.9506 12 20.9506" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 20.9506C10 20.9506 7 16.9999 7 10.9999C7 4.99994 10 1.04932 10 1.04932" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.62988 14.5H20.3706" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.62988 7.5H20.3706" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </button>
        <div className="active_lang">{activeFlag.name}</div>
      </div>
     
     <ul className="lang_list" ref={switcherRef} style={{display: langMenuDisplay}}>
      {lngsDropdown.map((lng) => (
          <li className="lang_list__li" onClick={() => selectLang(lng)} id={lng.id} key={lng.id}>
            {lng.name}
          </li>
        ))
      }
     </ul>
    </div>

    // <div className="langiageSwitcher">
    /* {
        Object.keys(lngs).map((lng) => (
          lng !== activeFlag && 
          <IconButton 
            sx={{padding: 0}}
            key={lng} 
            onClick={() => onClickLanguageSwitcher(lng)}
          >
            {lngs[lng].nativeName}
          </IconButton>
        ))
      } */
    /* {activeFlag === "en" ? (
        <button onClick={() => changeLanguage("est")}>
          <img className="Estonia" src={Estonia} />
        </button>
      ) : (
        <button onClick={() => changeLanguage("en")}>
          <img className="United Kingdom" src={UnitedKingdom} />
        </button>
      )} */

    /* {activeFlag === "en" ? (
        <IconButton sx={{ padding: 0 }} onClick={() => changeLanguage("est")}>
          <img className="Estonia" src={Estonia} />
        </IconButton>
      ) : (
        <IconButton sx={{ padding: 0 }} onClick={() => changeLanguage("en")}>
          <img className="United Kingdom" src={UnitedKingdom} />
        </IconButton>
      )}
    </div> */
  );
};

export default LanguageSwitcher;
